// Controllers/Inventory/Adjustments.js
import axios from "axios";
import APIURL from "../../../Main/apiurl";

const create_inventory_adjustment = async (adjustment) => {
    try {
        const data = {
            inventory: adjustment?.inventory,
            type: adjustment?.type,
            quantity: adjustment?.quantity,
            reason: adjustment?.reason,
            note: adjustment?.note,
            image: adjustment?.image,
            date: adjustment?.date,
        };

        const token = localStorage.getItem("user");
        const config = {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        };

        const response = await axios.post(
            `${APIURL}/create-inventory-adjustment`,
            data,
            config
        );
        return response?.data;
    } catch (error) {
        return error;
    }
};

const update_inventory_adjustment = async (adjustment) => {
    try {
        const data = {
            id: adjustment?.id,
            inventory: adjustment?.inventory,
            type: adjustment?.type,
            quantity: adjustment?.quantity,
            reason: adjustment?.reason,
            note: adjustment?.note,
            image: adjustment?.image,
            date: adjustment?.date,
            status: adjustment?.status,
        };

        const token = localStorage.getItem("user");
        const config = {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        };

        const response = await axios.post(
            `${APIURL}/update-inventory-adjustment`,
            data,
            config
        );
        return response?.data;
    } catch (error) {
        return error;
    }
};

const get_inventory_adjustment = async (adjustment) => {
    try {
        const data = {
            id: adjustment?.id,
        };

        const token = localStorage.getItem("user");
        const config = {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        };

        const response = await axios.post(
            `${APIURL}/get-inventory-adjustment`,
            data,
            config
        );
        return response?.data;
    } catch (error) {
        return error;
    }
};

const get_all_inventory_adjustments = async (adjustment) => {
    try {
        const data = {
            search: adjustment?.search,
            sort: adjustment?.sort,
            type: adjustment?.type,
            date: adjustment?.date,
            status: adjustment?.status,
            page: adjustment?.page,
        };

        const token = localStorage.getItem("user");
        const config = {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        };

        const response = await axios.post(
            `${APIURL}/get-all-inventory-adjustments`,
            data,
            config
        );
        return response?.data;
    } catch (error) {
        return error;
    }
};

const delete_inventory_adjustment = async (adjustment) => {
    try {
        const data = {
            id: adjustment?.id,
        };

        const token = localStorage.getItem("user");
        const config = {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        };

        const response = await axios.post(
            `${APIURL}/delete-inventory-adjustment`,
            data,
            config
        );
        return response?.data;
    } catch (error) {
        return error;
    }
};

export {
    create_inventory_adjustment,
    update_inventory_adjustment,
    get_inventory_adjustment,
    get_all_inventory_adjustments,
    delete_inventory_adjustment,
};